import { Injectable, Inject, forwardRef } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { getManager } from 'typeorm';
import { LoansResponseModel } from '@gtpl/shared-models/gtpl';
import { LoansDTO } from './dto/loans.dto';
@Injectable()
export class LoansService {

  constructor(
   
  ) {}
  // @LogActions({isAsync: true})
  async getLoans(loansRequest:LoansDTO):Promise<LoansResponseModel> {
    const manager = getManager();
    console.log(loansRequest.employeeId);
    let query='SELECT loandetails.id AS loanId,loandetails.Loan_Account_Number AS loanAccountNumber,emi,Total_Receivable AS totalReceivable,total_amount_paid AS totalAmountPaid,DAY(current_month_duedate) AS dueDate,current_month_emi,customers.customer_name AS customerName,customers.telephone AS mobileNumber FROM loandetails LEFT JOIN customers ON customers.id=loandetails.customer_name where loan_status<>"Close"';
    if(loansRequest.employeeId>0){
      query+=' and loandetails.executive_name='+loansRequest.employeeId;
    }
    query+=' order by loandetails.id desc';
    const loanDetails = await manager.query(query);
    const response = new LoansResponseModel(true, 11100, 'loans retrived successfully', loanDetails);
    return response;
    // return loanDetails;
  }
 
}